import React from "react";
import { Button } from "@material-ui/core";

/**
 * The "Show data" / "Hide data" toggle, at a width that does not change.
 *
 * Both labels are rendered into the same grid cell, one of them invisible, so
 * the button is always exactly as wide as the wider label and the controls to
 * its right never shift when it is clicked. Only the visible label is exposed
 * to assistive technology.
 */
export default function ShowDataButton({ open, onClick }) {
  return (
    <Button size="small" onClick={onClick} aria-expanded={open}>
      <span style={{ display: "grid" }}>
        <span
          style={{
            gridArea: "1 / 1",
            visibility: open ? "hidden" : "visible",
          }}
          aria-hidden={open}
        >
          Show data
        </span>
        <span
          style={{
            gridArea: "1 / 1",
            visibility: open ? "visible" : "hidden",
          }}
          aria-hidden={!open}
        >
          Hide data
        </span>
      </span>
    </Button>
  );
}
